import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { HttpTimeoutError } from '@cian/peperrors/shared';
import {
  fetchCianApiSiteV1GetRegions,
  TCianApiSiteV1GetRegionsResponse,
} from '../repositories/monolith-python/cian-api/site/v1/get-regions';
import { IGetRegionsResponseSchema52 } from '../repositories/monolith-python/entities/schemas/GetRegionsResponseSchema52';
import { getRegionsApiCache, GET_REGIONS_API_CACHE_KEY } from './getRegionsApiCache';

export async function getRegions(httpApi: IHttpApi, logger: ILogger) {
  const cacheData = getRegionsApiCache.getData<IGetRegionsResponseSchema52>(GET_REGIONS_API_CACHE_KEY);
  if (cacheData) {
    return cacheData;
  }

  try {
    const result = await fetchCianApiSiteV1GetRegions<
      TCianApiSiteV1GetRegionsResponse,
      TCianApiSiteV1GetRegionsResponse
    >({ httpApi });

    if (result.statusCode !== 200) {
      throw result.response;
    }

    getRegionsApiCache.setData(GET_REGIONS_API_CACHE_KEY, result.response);

    return result.response;
  } catch (error) {
    const message = HttpTimeoutError.is(error) ? 'TimeoutError in getRegions' : 'Error in getRegions';

    logger.error(error, { message });

    return { data: { items: [] } };
  }
}
